var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.831,
    height: 18.786,
    viewBox: "0 0 14.831 18.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.048,
    y1: 250.588,
    x2: 0.509,
    y2: 250.127,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-document",
    transform: "translate(-9 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53446",
    "data-name": "Path 53446",
    d: "M23.831,10.438V22.8a.988.988,0,0,1-.989.989H9.989A.988.988,0,0,1,9,22.8V5.989A.988.988,0,0,1,9.989,5h8.4l1.483,3.955Z",
    transform: "translate(0 0)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53447",
    "data-name": "Path 53447",
    d: "M28,5V9.449a.988.988,0,0,0,.989.989h4.449Z",
    transform: "translate(-9.607 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53448",
    "data-name": "Path 53448",
    d: "M23.652,22.989h-8.4A.247.247,0,0,1,15,22.742v-.494A.247.247,0,0,1,15.247,22h8.4a.247.247,0,0,1,.247.247v.494A.247.247,0,0,1,23.652,22.989Z",
    transform: "translate(-3.034 -8.596)",
    fill: "#057093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53449",
    "data-name": "Path 53449",
    d: "M22.663,26.989H15.247A.247.247,0,0,1,15,26.742v-.494A.247.247,0,0,1,15.247,26h7.416a.247.247,0,0,1,.247.247v.494A.247.247,0,0,1,22.663,26.989Z",
    transform: "translate(-3.034 -10.618)",
    fill: "#057093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53450",
    "data-name": "Path 53450",
    d: "M23.652,30.989h-8.4A.247.247,0,0,1,15,30.742v-.494A.247.247,0,0,1,15.247,30h8.4a.247.247,0,0,1,.247.247v.494A.247.247,0,0,1,23.652,30.989Z",
    transform: "translate(-3.034 -12.641)",
    fill: "#057093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53451",
    "data-name": "Path 53451",
    d: "M22.663,34.989H15.247A.247.247,0,0,1,15,34.742v-.494A.247.247,0,0,1,15.247,34h7.416a.247.247,0,0,1,.247.247v.494A.247.247,0,0,1,22.663,34.989Z",
    transform: "translate(-3.034 -14.663)",
    fill: "#057093"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3b696e0aa30120bf00e6ceafff7d4efb.svg";
export { ForwardRef as ReactComponent };